import { FC } from 'react';
import { TabsContent } from 'ui/tabsGroup';
import { PerformanceOverTimeTabContentWrapper } from 'modules/intelligentInsights/frequencyOptimization/components/performanceOverTime/PerformanceOverTime.styles';
import { useFroInsightsCoreContext } from 'modules/intelligentInsights/frequencyOptimization/contexts/CoreContext';
import { PerformanceOverTimeGraph } from 'modules/intelligentInsights/frequencyOptimization/components/performanceOverTime/PerformanceOverTimeGraph';

export const PEFORMANCE_TAB_CONTENT_TEST_ID = 'performance-tab-content-trigger';

export const PeformanceGraphTabContent: FC = () => {
  const { selectedLiftTab, froInsightsData } = useFroInsightsCoreContext();

  return (
    <TabsContent
      data-test={`${selectedLiftTab}-${PEFORMANCE_TAB_CONTENT_TEST_ID}`}
      key={selectedLiftTab}
      value={selectedLiftTab}
    >
      <PerformanceOverTimeTabContentWrapper>
        <PerformanceOverTimeGraph
          selectedLiftTab={selectedLiftTab}
          froInsightsData={froInsightsData}
        />
      </PerformanceOverTimeTabContentWrapper>
    </TabsContent>
  );
};
